// extracted by mini-css-extract-plugin
module.exports = {"noMargin":"basket_noMargin__1UVmF"};